import { SubjectShort } from 'src/@types/modules/subjects/subjects.types'
import { provideTags } from 'src/api/utils/functions/provide-tags';
import { baseApi, QueryPayload } from 'src/api';

const api = baseApi.injectEndpoints({
    endpoints: builder => ({
        getSubjects: builder.query<SubjectShort[], null | void>({
            providesTags: (res) => provideTags('Subjects', res),
            query: (): QueryPayload => {
                return {
                    url: '/subjects',
                    method: 'GET',
                }
            },
        }),
        
        getSubject: builder.query<SubjectShort, { params: { subjectId: number } }>({
            providesTags: (_res, _err, { params }) =>
                [{ type: 'Subjects', id: params.subjectId }],
            query: ({ params }): QueryPayload => ({
                url: `/subjects/${params.subjectId}`,
                method: 'GET',
            }),
        }),
        
        createSubject: builder.mutation<void, { body: { name: string } }>({
            invalidatesTags: [
                { type: 'Subjects', id: 'LIST' },
            ],
            query: ({ body }): QueryPayload => ({
                url: '/subjects',
                method: 'POST',
                data: body,
            }),
        }),
        
        updateSubject: builder.mutation<void, { body: { name: string }, params: { subjectId: number } }>({
            invalidatesTags: (_res, _err, { params }) => [
                { type: 'Subjects', id: 'LIST' },
                { type: 'Subjects', id: params.subjectId },
            ],
            query: ({ body, params }): QueryPayload => ({
                url: `/subjects/${params.subjectId}`,
                method: 'PATCH',
                data: body,
            }),
        }),
        
        deleteSubject: builder.mutation<void, { params: { subjectId: number } }>({
            invalidatesTags: (_res, _err, { params }) => [
                { type: 'Subjects', id: 'LIST' },
                { type: 'Subjects', id: params.subjectId },
            ],
            query: ({ params }): QueryPayload => ({
                url: `/subjects/${params.subjectId}`,
                method: 'DELETE',
            }),
        }),
    }),
})

export const {
    useGetSubjectsQuery,
    useGetSubjectQuery,
    useCreateSubjectMutation,
    useUpdateSubjectMutation,
    useDeleteSubjectMutation,
} = api